import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const stagesVariants = cva('flex items-center', {
	variants: {
		layout: {
			/** Single horizontal row. Tip of each chevron overlaps next item via gap-5. */
			row:  'gap-5 pr-[30px]',
			/** Wraps to next line when running out of width. */
			wrap: 'flex-wrap content-center gap-y-2 gap-x-5 pr-4',
			/** Stretched columns for kanban-like deal board (each child `flex-1`). */
			columns: 'gap-5 [&>*]:flex-1',
		},
	},
	defaultVariants: { layout: 'row' },
})

export interface StagesProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof stagesVariants> {}

const Stages = React.forwardRef<HTMLDivElement, StagesProps>(
	({ className, layout, children, ...props }, ref) => (
		<div ref={ref} className={cn(stagesVariants({ layout, className }))} {...props}>
			{children}
		</div>
	)
)

Stages.displayName = 'Stages'
export { Stages, stagesVariants }
